/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalCostDtoFromJSON, ExternalCostDtoToJSON, } from './ExternalCostDto';
/**
 * Check if a given object implements the ProjectExternalCost interface.
 */
export function instanceOfProjectExternalCost(value) {
    return true;
}
export function ProjectExternalCostFromJSON(json) {
    return ProjectExternalCostFromJSONTyped(json, false);
}
export function ProjectExternalCostFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'intranetId': json['intranetId'] == null ? undefined : json['intranetId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'externalCosts': json['externalCosts'] == null ? undefined : (json['externalCosts'].map(ExternalCostDtoFromJSON)),
    };
}
export function ProjectExternalCostToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'projectId': value['projectId'],
        'intranetId': value['intranetId'],
        'projectName': value['projectName'],
        'externalCosts': value['externalCosts'] == null ? undefined : (value['externalCosts'].map(ExternalCostDtoToJSON)),
    };
}
